import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 1:1 미술품 거래 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 유명 작가의 ‘실물’ 작품을 구매 & 판매 해보세요 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 미술품 더보기 ")

import {Plugins} from '@capacitor/core'
import {ref, onMounted, computed, getCurrentInstance} from 'vue'
import {cookieSoftStorage} from '@/utils/storage'
import {AgBoxS} from '@/components/ag'
import {useInAppBrowser} from '@/composables/in-app-browser'
import {nextAppUrl, apiUrl, allowDomain} from '@/environment'
import {useShare, getPlatform} from '@/composables'
import Axios from 'axios'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const app = getCurrentInstance()
const $global = app && app.appContext.config.globalProperties.$global
const {Browser} = Plugins
const share = useShare()
const nextUrl = ref()
const link = ref('판매가격 보러가기 >')
const description = ref('description')
const title = ref('title')
const linkUrl = ref<string | undefined>()
const imageSrc = ref<string | undefined>()
const color = ref('white')
const axios = Axios.create({
  baseURL: apiUrl(),
})

const getToken = () => {
  return localStorage.getItem('token')
}

const getUrl = (nextUrl: string = '/pages/art/list') => {
  const platform = getPlatform()
  const token = getToken()
  return `${nextAppUrl()}${nextUrl}?platform=${platform}${token ? `&token=${token}`: ''}`
}

const inAppBrowser = useInAppBrowser(
    getUrl(),
    '_black',
    {
      presentationStyle: 'fullscreen',
      useWkWebView: true,
    },
)

const showBanner = computed(() => {
  return Boolean(imageSrc.value)
})

onMounted(async () => {
  const response = await axios.get('/arts/banner')
  const {bannerDescription, bannerTitle, imageUrl, link, colorCode} = response.data?.data ?? {}
  title.value = bannerTitle
  description.value = bannerDescription
  imageSrc.value = imageUrl
  linkUrl.value = link
  color.value = colorCode ? colorCode : color.value
})


const setCookieToken = () => {
  const token = getToken()
  cookieSoftStorage.setItem('user', {token}, {domain: allowDomain(), sameSite: 'strict'})
}

const login = async () => {
  inAppBrowser.close()
  $global.openLoginModal(() => {
    onOpenArtList()
  })
}

const onOpenArtList = () => {
  const platform = getPlatform()
  const _nextUrl = nextUrl.value
  setCookieToken()
  if (_nextUrl) {
    nextUrl.value = undefined
  }
  const url = getUrl(_nextUrl)
  if (platform === 'web') {
    location.href = url
    return
  }
  inAppBrowser.open(url)
}


inAppBrowser.onMessage((message) => {
  const {close, openLink, share: _share, login: _login, reopenTo} = message

  nextUrl.value = reopenTo

  if (close) {
    inAppBrowser.close()
    return
  }
  if (openLink) {
    Browser.open({url: openLink})
    return
  }
  if (_share) {
    share(_share)
  }

  if (_login) {
    login()
  }
})


return (_ctx: any,_cache: any) => {
  const _directive_track = _resolveDirective("track")!

  return (_unref(showBanner))
    ? (_openBlock(), _createBlock(_unref(AgBoxS), {
        key: 0,
        css: {px: 20, py: 24}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {typography:'tit24b'} }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {typography:'text14r', color:'gray2', mb:20} }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_unref(AgBoxS), {
            css: {
        cursor: 'pointer',
        width: '100%',
        position: 'relative',
        height: 240,
        p: 16,
        dp: 'flex',
        direction: 'column',
        corner: 10,
        overflow: 'hidden',
        mb: 8,
      },
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onOpenArtList()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(AgBoxS), {
                css: {position: 'absolute', left: 0, top: 0, width: '100%', objectFit: 'cover'},
                src: imageSrc.value,
                "container-as": "img"
              }, null, 8, ["src"]),
              _createVNode(_unref(AgBoxS), { css: {
          position: 'absolute',
          left: 0, top: 0, width: '100%', height: '100%',
          background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 60.83%, rgba(0, 0, 0, 0.8) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))'} }, null, 8, ["css"]),
              _createVNode(_unref(AgBoxS), {
                css: {typography: 'tit24b', color: color.value, grow: 1}
              }, null, 8, ["css"]),
              _createVNode(_unref(AgBoxS), {
                css: {typography: 'tit18b', color: color.value}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(title.value), 1)
                ]),
                _: 1
              }, 8, ["css"]),
              _createVNode(_unref(AgBoxS), {
                css: {typography: 'tit14b', color: color.value}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(description.value), 1)
                ]),
                _: 1
              }, 8, ["css"]),
              _createVNode(_unref(AgBoxS), {
                css: {typography: 'main14r', color: color.value , mt: 4}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(link.value), 1)
                ]),
                _: 1
              }, 8, ["css"])
            ]),
            _: 1
          }, 512), [
            [_directive_track, {clickArea: 'ART 배너', clickContent: 'ART 배너'}]
          ]),
          _withDirectives(_createVNode(_unref(AgBoxS), {
            css: {
        cursor: 'pointer',
        minHeight: 48,
        width: '100%',
        corner: 6,
        border: '1px solid #EEF1F7',
        dp: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'font',
        typography: 'h9'
      },
            onClick: onOpenArtList
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 512), [
            [_directive_track, {clickArea: '미술품 더보기', clickContent: '더보기'}]
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})